// Public cargo-site copy. Forms on these pages stay in the browser.
// Photo stand-in for every site image until the final pictures are swapped in.
import vehiclePhoto from "../../static/images/vehicle.jpg";

export const vehicleImage = vehiclePhoto;

export const company = {
  name: "Essaar",
  fullName: "Essaar Transport & Logistics",
  shortName: "Essaar Logistics",
  tagline: "Parcels and part loads across Tamil Nadu, Karnataka, Kerala and Puducherry, from a Coimbatore-headquartered partnership firm.",
  phone: "92442 28896",
  phoneHref: "tel:+919244228896",
  email: "care@essaar.net",
  emailHref: "mailto:care@essaar.net",
  website: "www.essaarlogistics.net",
  websiteHref: "https://www.essaarlogistics.net",
  busWebsite: "www.essaar.net",
  busWebsiteHref: "https://www.essaar.net",
  busPhone: "84899 10650",
  headOffice: "Coimbatore, Tamil Nadu",
  gstin: "33AABFE7640P1Z7",
};

export const navLinks = [
  { name: "Home", path: "/" },
  { name: "Branches", path: "/branches" },
  { name: "Service Enquiry", path: "/service-enquiry" },
  { name: "Complaints", path: "/complaints" },
  { name: "About Us", path: "/about" },
  { name: "Contact Us", path: "/contact-us" },
];

export const supportLinks = [
  { name: "Track a consignment", path: "/track-shipment" },
  { name: "Service enquiry", path: "/service-enquiry" },
  { name: "Register a complaint", path: "/complaints" },
  { name: "Branch locator", path: "/branches" },
];

export const companyLinks = [
  { name: "About Essaar", path: "/about" },
  { name: "Contact us", path: "/contact-us" },
  { name: "Bus tickets (essaar.net)", href: company.busWebsiteHref, external: true },
  { name: "Terms & conditions", path: "/terms-conditions" },
];

export const states = ["Tamil Nadu", "Karnataka", "Kerala", "Puducherry"];

export const branches = [
  {
    id: "coimbatore-powerhouse",
    name: "Coimbatore - Powerhouse",
    city: "Coimbatore",
    state: "Tamil Nadu",
    type: "Booking branch",
    address: "Address and pincode to be updated",
    phone: "Branch phone to be updated",
    hours: "Working hours to be updated",
  },
  {
    id: "nagercoil",
    name: "Nagercoil",
    city: "Nagercoil",
    state: "Tamil Nadu",
    type: "Delivery branch",
    address: "Address and pincode to be updated",
    phone: "Branch phone to be updated",
    hours: "Working hours to be updated",
  },
  {
    id: "tamil-nadu",
    name: "Tamil Nadu branch",
    city: "Tamil Nadu",
    state: "Tamil Nadu",
    type: "Booking / delivery",
    address: "Address and pincode to be updated",
    phone: "Branch phone to be updated",
    hours: "Working hours to be updated",
  },
  {
    id: "karnataka",
    name: "Karnataka branch",
    city: "Karnataka",
    state: "Karnataka",
    type: "Booking / delivery",
    address: "Address and pincode to be updated",
    phone: "Branch phone to be updated",
    hours: "Working hours to be updated",
  },
  {
    id: "kerala",
    name: "Kerala branch",
    city: "Kerala",
    state: "Kerala",
    type: "Booking / delivery",
    address: "Address and pincode to be updated",
    phone: "Branch phone to be updated",
    hours: "Working hours to be updated",
  },
  {
    id: "puducherry",
    name: "Puducherry branch",
    city: "Puducherry",
    state: "Puducherry",
    type: "Booking / delivery",
    address: "Address and pincode to be updated",
    phone: "Branch phone to be updated",
    hours: "Working hours to be updated",
  },
];

export const services = [
  {
    icon: "package",
    title: "Part-load parcels",
    description: "Book a single parcel or several, branch to branch, and pay only for what you send.",
  },
  {
    icon: "truck",
    title: "Door pickup",
    description: "We collect from your shop, godown or home and book it in at the origin branch.",
  },
  {
    icon: "pin",
    title: "Door delivery",
    description: "Have it brought to the consignee's address, or collect it from the delivery branch.",
  },
  {
    icon: "warehouse",
    title: "Business shipping",
    description: "Regular consignors get a single point of contact. Credit terms and contract rates can be added when they are offered.",
  },
  {
    icon: "shield",
    title: "GST bill & e-way bill support",
    description: "Consignor and consignee GSTIN, declared value and e-way bill details are recorded on the bill.",
  },
  {
    icon: "route",
    title: "QR tracking",
    description: "Scan the QR on your bill to follow your consignment from booking to delivery.",
  },
];

export const steps = [
  {
    step: "01",
    title: "Book",
    description: "Walk into your nearest branch, call the helpline, or send a service enquiry online.",
  },
  {
    step: "02",
    title: "Get your LR",
    description: "You receive a lorry receipt with your LR number, charges and a tracking QR code.",
  },
  {
    step: "03",
    title: "In transit",
    description: "Your consignment moves to the delivery branch. Scan the QR or enter the LR number any time.",
  },
  {
    step: "04",
    title: "Delivered",
    description: "The consignee collects from the delivery branch, or receives it at the door if you chose door delivery.",
  },
];

export const serviceNeeds = [
  "Part-load parcel",
  "Door pickup",
  "Door delivery",
  "Business / regular shipping",
  "Something else",
];

export const complaintTypes = [
  "Delay",
  "Damage",
  "Shortage or missing",
  "Wrong delivery",
  "Billing or charges",
  "Staff conduct",
  "Something else",
];

export const contactTopics = [
  "General",
  "Booking help",
  "Tracking",
  "Billing",
  "Business account",
];

export const habits = [
  {
    title: "Paperwork that is complete",
    description: "Every consignment gets a lorry receipt with consignor and consignee details, GSTIN, declared value and e-way bill information, so nothing is missing at checkpoints or at delivery.",
  },
  {
    title: "A parcel you can follow",
    description: "The QR code on your bill opens live tracking. You should never have to phone a branch just to ask where your goods are.",
  },
  {
    title: "A problem that gets an owner",
    description: "Complaints are registered against the LR number, reach both branches and head office, and are followed until they are closed.",
  },
];

export const people = [
  { name: "Name to be updated", role: "Designation to be updated" },
  { name: "Name to be updated", role: "Designation to be updated" },
  { name: "Name to be updated", role: "Designation to be updated" },
];

export const contactDesks = [
  { title: "Bookings and pickup", detail: "Phone and email to be updated" },
  { title: "Delivery and tracking", detail: "Phone and email to be updated" },
  { title: "Billing and GST", detail: "Phone and email to be updated" },
  { title: "Business accounts", detail: "Phone and email to be updated" },
];
